const authenticationKeys = [
  "authToken",
  "token",
  "isLoggedIn",
  "vendorProfile",
  "adminProfileImage",
];

export const normalizeAuthToken = (token) =>
  String(token || "").trim().replace(/^(?:Bearer\s+)+/i, "").trim();

export const getAuthToken = () =>
  normalizeAuthToken(window.localStorage.getItem("authToken"));

export const clearAuthenticationStorage = () => {
  [window.localStorage, window.sessionStorage].forEach((storage) => {
    authenticationKeys.forEach((key) => storage.removeItem(key));
  });
};
